import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

const Card = ({ ok, pending, title, line, testId }) => (
  <div className="owner-login-wrap">
    <motion.div className="owner-card owner-login" initial={{ y: 20, opacity: 0.3 }} animate={{ y: 0, opacity: 1 }}
      data-testid={testId}>
      <h1 style={{ color: ok ? "#8be3b0" : pending ? "#edc48c" : "#ff9cbb" }}>{title}</h1>
      <p>{line}</p>
      <Link to="/" className="cta" data-testid="payment-back-home">Back to the House</Link>
    </motion.div>
  </div>
);

export default function PaymentResult() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(sessionId ? "pending" : "missing");

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
        if (data.payment_status === "failed" || data.status === "expired") return setState("failed");
      } catch { /* keep polling */ }
      if (tries < 15) setTimeout(poll, 2000);
      else setState("unknown");
    };
    poll();
  }, [sessionId]);

  if (state === "paid")
    return <Card ok title="Deposit received! 💜" testId="payment-success"
      line="Your $15 deposit is in. Smiless has you on the books — see you soon, boo!" />;
  if (state === "pending")
    return <Card pending title="Checking your payment…" testId="payment-pending" line="One moment, loves." />;
  return <Card title="Deposit not completed" testId="payment-cancel"
    line={sessionId ? "That payment didn't go through, or the link expired. Check with Smiless before trying again."
      : "No payment session found. Check with Smiless before trying again."} />;
}
